export default "__VITE_ASSET__fd600ecd__"